import React from 'react';
import PropTypes from 'prop-types';

import { EditMapPageTitle, EditMapPageDescription } from 'components';
import { ifDataReturnComponent } from 'utils';
import { StyledEditMapPageInfo } from './style';


const EditMapPageInfo = ({ name, description }) => (
  <StyledEditMapPageInfo>
    {ifDataReturnComponent(name)(<EditMapPageTitle title={name} />)}
    <EditMapPageDescription name={name} description={description} />
  </StyledEditMapPageInfo>
);

EditMapPageInfo.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
};

EditMapPageInfo.defaultProps = {
  name: '',
  description: '',
};

export default EditMapPageInfo;
